/** Mirror ntcog-api KpiDependencyConflictConstants. */
export const ERRORS_REASON = "reason";
export const ERRORS_SUBJECT = "subject";
export const ERRORS_DEPENDENTS = "dependents";
export const REMOVED_ACTIVITIES = "removed_activities";
export const DEPENDS_ON_ACTIVITIES = "depends_on_activities";

export const REASON_ACTIVITY_REMOVED_FROM_TEMPLATE = "activity_removed_from_template";
export const REASON_KPI_REMOVED_FROM_ACTIVITY = "kpi_removed_from_activity";
export const REASON_KPI_DISABLED = "kpi_disabled";

export const SUBJECT_KPI_ID = "kpi_id";
export const SUBJECT_KPI_NAME = "kpi_name";
export const SUBJECT_ACTIVITY_ID = "activity_id";
export const SUBJECT_ACTIVITY_NAME = "activity_name";

export const TITLE_ACTIVITY_REMOVED_FROM_TEMPLATE = "Activities can't be removed";
export const TITLE_KPI_REMOVED_FROM_ACTIVITY = "This KPI can't be removed";
export const TITLE_KPI_DISABLED = "This KPI can't be disabled";
export const TITLE_UNKNOWN_CONFLICT = "This change can't be saved";

export const PARAGRAPH_ACTIVITY_REMOVED_FROM_TEMPLATE =
  "Some activities can't be removed because calculated KPIs on this template depend on them. Keep these activities on the template to save your changes. To remove them, the KPI formulas need to be updated first.";

export const LABEL_AFFECTED_KPIS = "Affected calculated KPIs";
export const LABEL_ACTIVITY_REMOVED = "Activity removed:";
export const LABEL_THESE_CALCULATED_KPIS_NEED_IT = "These calculated KPIs need it:";
export const PREFIX_USES = "Uses ";
export const LIST_JOIN_SERIAL = ", ";
export const LIST_JOIN_FINAL = " and ";

export const LABEL_NOT_ON_TEMPLATE = "Not on a template yet";

export const BUTTON_BACK_TO_ACTIVITIES = "Back to activities";
export const BUTTON_GOT_IT = "Got it";

export const ATTENTION_REQUIRED_TITLE = "Attention Required";
export const ATTENTION_REQUIRED_INTRO = "Please fix the following before continuing:";

export const KPI_CONFLICT_LIST_MAX_HEIGHT = "min(40vh, 16rem)";

export const VALIDATION_MODAL_TITLE_ID = "validation-error-modal-title";
export const VALIDATION_MODAL_DESC_ID = "validation-error-modal-desc";
export const KPI_CONFLICT_MODAL_TITLE_ID = "kpi-conflict-modal-title";
export const KPI_CONFLICT_MODAL_DESC_ID = "kpi-conflict-modal-desc";
